import { AutogenLayoutOfficePayrollJournalReport } from "./autogen/AutogenLayoutOfficePayrollJournalReport";

export class OfficePayrollJournalReport extends AutogenLayoutOfficePayrollJournalReport {
    override onLoad(): void {
        super.onLoad();
        this.textboxReportType.selectedItem = this.textboxReportType.items[0];
    }

    reportTypeChanged() {
        const reportType = this.textboxReportType.text;

        if (reportType.startsWith("Totals Only")) {
            this.switchSort.enabled = false;
        } else {
            this.switchSort.enabled = true;
        }
    }
}
